import {
  CHECKOUT_REFUND_PATH,
  ScanDetectedEvent,
  parseSalesOrderWorkorderBarcode,
  useListenScanDetected
} from "@ubif/util-store";
import { useState } from "react";
import { useLocation } from "react-router-dom";

import { SalesOrderWorkorderScanModal } from "./SalesOrderWorkorderScanModal";

interface ScannedReceiptBarcode {
  salesOrderId: string;
  workorderId: string;
}

// Refund auto-fills the SO field from the scan, so we let it own the scan there.
const SUPPRESSED_PATH_PREFIXES = [CHECKOUT_REFUND_PATH];

/**
 * Listens for combined sales-order / workorder receipt barcodes (SO…/WO…) scanned
 * anywhere in the app and prompts the technician to open the workorder or start a refund.
 */
export const SalesOrderWorkorderScanListener = () => {
  const location = useLocation();
  const [scannedBarcode, setScannedBarcode] = useState<ScannedReceiptBarcode | null>(null);

  const handleScan = (scanEvent: ScanDetectedEvent) => {
    const parsed = parseSalesOrderWorkorderBarcode(scanEvent.scan);
    if (!parsed) return;

    const isSuppressed = SUPPRESSED_PATH_PREFIXES.some((prefix) => location.pathname.startsWith(prefix));
    if (isSuppressed) return;

    setScannedBarcode(parsed);
  };

  useListenScanDetected(handleScan);

  if (!scannedBarcode) return null;

  return (
    <SalesOrderWorkorderScanModal
      salesOrderId={scannedBarcode.salesOrderId}
      workorderId={scannedBarcode.workorderId}
      onClose={() => setScannedBarcode(null)}
    />
  );
};
